import { shouldShowVenuePricing } from '../utils/venuePricing';

export const venueImages = [
  "https://images.unsplash.com/photo-1508921340878-ba53e1f016ec", // modern event hall
  "https://images.unsplash.com/photo-1484154218962-a197022b5858", // rustic barn venue
  "https://images.unsplash.com/photo-1531058020387-3be344556be6", // rooftop venue
  "https://images.unsplash.com/photo-1505691938895-1758d7feb511", // conference space
  "https://images.unsplash.com/photo-1521737604893-d14cc237f11d", // auditorium
  "https://images.unsplash.com/photo-1522202176988-66273c2fd55f", // co-working space
  "https://images.unsplash.com/photo-1492684223066-81342ee5ff30", // indoor banquet hall
  "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267", // loft-style venue
  "https://images.unsplash.com/photo-1484154218962-7bdd8bde35b9", // art gallery
  "https://images.unsplash.com/photo-1522770179533-24471fcdba45"  // wedding venue
];
// Calendar helper functions
export const generateCalendarDates = (year, month) => {
  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);
  const daysInMonth = lastDay.getDate();
  const startingDay = firstDay.getDay();
  const today = new Date();
  const currentDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());

  const dates = [];

  // Add empty cells for days before the first day of the month
  for (let i = 0; i < startingDay; i++) {
    dates.push(null);
  }

  // Add all days of the month with disabled status for past dates
  for (let i = 1; i <= daysInMonth; i++) {
    const dateToCheck = new Date(year, month, i);
    const isPastDate = dateToCheck < currentDate;
    dates.push({
      day: i,
      disabled: isPastDate
    });
  }

  return dates;
};

export const getMonthName = (month) => {
  const months = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];
  return months[month];
};

export const formatDate = (day, month, year) => {
  // Return ISO format (YYYY-MM-DD) for consistency across all pages
  const paddedMonth = String(month + 1).padStart(2, '0'); // month is 0-indexed
  const paddedDay = String(day).padStart(2, '0');
  return `${year}-${paddedMonth}-${paddedDay}`;
};

// Helper to format ISO date for display
export const formatDateForDisplay = (isoDate) => {
  if (!isoDate) return '';
  const date = new Date(isoDate);
  const month = date.getMonth();
  const day = date.getDate();
  const year = date.getFullYear();
  return `${getMonthName(month)} ${day}, ${year}`;
};

export const EVENT_TYPES = [
    "Wellness",
    "Arts", 
    "Community",
    "Celebrations",
    "Series"
]

// Real venue data from survey responses
export const REAL_VENUE_DATA = [
  {
    id: 1,
    name: "The Cherish Club",
    image: "https://images.unsplash.com/photo-1527192491265-7e15c55b1ed2?q=80&w=2340&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    contact: "Alyssia Sykes",
    rating: 4.8,
    email: "Info@thecherishclub.co.uk",
    role: "Director",
    address: "Bridgeman Street, NW8 7AL",
    city: "London",
    description: "One cafe space, two dance studios.",
    vibe: ["Cosy", "relaxed", "Welcoming"],
    organizesEvents: true,
    eventTypes: "Varied, please send me your required dates",
    platforms: ["Tag venue"],
    spaces: ["Cafe and studios"],
    maxCapacity: 20,
    standingCapacity: 20,
    facilities: ["Natural light space"],
    kidFriendly: true,
    availability: "Yes, all hours",
    suitableEvents: "Any!",
    pricing: "Varied",
    recurringDiscount: false,
    offPeakDiscount: false,
    hourlyRate: 45,
    minimumBooking: "No",
    challenges: "",
    platformValue: "",
    interested: true,
    coordinates: { lat: 51.5200, lng: -0.1900 }, // Approximate for NW8 7AL
    amenities: {
      foodBeverage: {
        inHouseCatering: [
          { name: "Extensive vegan menu", available: true },
          { name: "Complimentary water", available: true },
          { name: "Complimentary tea and coffee", available: true }
        ],
        externalCatering: [
          { name: "Buyout fee for external catering", available: true },
          { name: "Kitchen facilities available for guests", available: false }
        ],
        alcohol: {
          venueProvides: false,
          byoAllowed: true,
          corkageFee: true
        }
      },
      eventRules: {
        allowedEvents: [
          { name: "Promoted and ticketed events", available: true },
          { name: "No temporary Event Notice (TENs) available", available: false },
          { name: "No wedding licence", available: false }
        ],
        hostRules: [
          "Smoking/vaping outside only",
          "Outside catering is allowed",
          "BYO alcohol is allowed"
        ],
        cancellationPolicy: "Flexible"
      },
      amenities: [
        { name: "Wi-Fi available", available: true },
        { name: "Air conditioner", available: true },
        { name: "Storage space", available: true },
        { name: "Paid parking is available on-site", available: true },
        { name: "Projector", available: false },
        { name: "Whiteboard", available: false },
        { name: "Conference call facilities", available: false },
        { name: "PA system / speakers", available: true },
        { name: "Natural light", available: true },
        { name: "Quiet space", available: true },
        { name: "Paid parking facilities available nearby", available: true },
        { name: "Flatscreen TV", available: false },
        { name: "Flipchart", available: false },
        { name: "Alcohol licence", available: false }
      ]
    }
  },
  {
    id: 2,
    name: "Anomalous Space",
    image: "https://images.squarespace-cdn.com/content/v1/64523cba1b345726c55f871b/5eabe34f-c10b-4aef-8897-071c1e05b4b9/Anomalous+Space_The+Home_1.jpg?format=2500w",
    contact: "Nina Culley",
    rating: 4.4,
    email: "Space@anomalous.co.uk",
    role: "Space Manager",
    city: "London",
    address: "36 Pentonville Rd N1 9HF",
    description: "A home away from home, Anomalous Space provides flexible environments for your remote or hybrid team to flourish. We're a friendly neighbourhood work space, studio and event venue that connects people, facilitates creativity and sparks inspiration.",
    vibe: ["homey", "bright", "versatile"],
    organizesEvents: true,
    eventTypes: "Sound baths, Writers workshops, yoga and healing, music events, music healing/presentations",
    platforms: ["Headbox", "Peerspace", "Conveenie", "Tag Venue", "Scouty", "Appear Here", "Giggster", "Flowspace", "Sharesy", "Hirespace", "Togather", "Venue Scanner"],
    spaces: ["Therapist room", "Film/photo studio space", "Meeting rooms", "Conference rooms", "Large hall for presentations, book launches, workshops, team building, parties etc."],
    maxCapacity: 100,
    standingCapacity: 55,
    facilities: ["Alcoholic drinks", "Non-alcoholic drinks", "Projector", "Sound System", "Screens", "Wi-Fi", "Conference call facilities", "Microphones", "Natural light space", "Accessible toilets", "Wheelchair accessible", "Parking", "External catering"],
    kidFriendly: true,
    availability: "Weekdays 8am-10pm, Saturday 9am-10pm, Sundays Closed",
    suitableEvents: "workshops, meetings, support groups, discussion clubs, charity events, book launches, yoga and healing, filming, photoshoots, clothes swaps, networking events",
    pricing: "Rates range between £15+vat p/h and £170+vat p/h",
    recurringDiscount: true,
    offPeakDiscount: false,
    hourlyRate: 35,
    minimumBooking: "4 hours minimum (can be negotiated to 3 if other clients in other spaces)",
    challenges: "Getting our name out there to the right people. We want to get more creative/community people in our spaces. Finding a range of both creative and corporate clients. Having recurring bookings from workshops being held.",
    platformValue: "Being exposed to the right clients and interested parties, with appealing win-rate of bookings. Having recurring, long term clients who use the space for creative and community events.",
    interested: true,
    coordinates: { lat: 51.5300, lng: -0.1100 }, // Approximate for N1 9HF
    amenities: {
      foodBeverage: {
        inHouseCatering: [
          { name: "Extensive vegan menu", available: true },
          { name: "Complimentary water", available: true },
          { name: "Complimentary tea and coffee", available: true },
          { name: "Halal menu", available: true }
        ],
        externalCatering: [
          { name: "Buyout fee for external catering", available: true },
          { name: "Kitchen facilities available for guests", available: true }
        ],
        alcohol: {
          venueProvides: true,
          byoAllowed: true,
          corkageFee: false
        }
      },
      eventRules: {
        allowedEvents: [
          { name: "Promoted and ticketed events", available: true },
          { name: "No temporary Event Notice (TENs) available", available: false },
          { name: "No wedding licence", available: false }
        ],
        hostRules: [
          "Smoking/vaping outside only",
          "Outside catering is allowed",
          "BYO alcohol is allowed"
        ],
        cancellationPolicy: "Moderate"
      },
      amenities: [
        { name: "Wi-Fi available", available: true },
        { name: "Air conditioner", available: true },
        { name: "Storage space", available: true },
        { name: "Paid parking is available on-site", available: true },
        { name: "Projector", available: true },
        { name: "Whiteboard", available: false },
        { name: "Conference call facilities", available: true },
        { name: "PA system / speakers", available: true },
        { name: "Natural light", available: true },
        { name: "Quiet space", available: true },
        { name: "Paid parking facilities available nearby", available: true },
        { name: "Flatscreen TV", available: false },
        { name: "Flipchart", available: false },
        { name: "Alcohol licence", available: true }
      ]
    }
  },
  {
    id: 3,
    name: "Laundry Studios",
    image: "https://images.squarespace-cdn.com/content/v1/66ca46d35d8573139e959243/736b5f49-130b-46ed-b27e-38631c73f099/6abe3900-5586-4075-9466-42e4517d17fe.jpeg?format=2500w",
    contact: "Kayla MacGregor",
    city: "London",
    rating: 4.5,
    email: "laundrystudios@withoneder.com",
    role: "Community Lead",
    address: "369 Mentmore Terrace",
    description: "The Laundry Studios is a beautifully designed, 2 level building. We are a shared workspace, with the option of spacious private offices. Some areas of the building can be hired for private events with one of our spaces holding up to 60 people seating/80 standing, as well as the extension of that space bringing the total to a capacity of 120.",
    vibe: ["Relaxed", "creative", "natural light"],
    organizesEvents: true,
    eventTypes: "Monthly events calendar with yoga Wednesdays, pastry morning and evening social every last Thursday, movie night in cinema room every 1st Wednesday, financial advisor sessions, Hackney Herbal tea-blending workshops, personal branding events, photo shoots, sip&paint sessions, corporate filming days",
    platforms: ["Multiple aggregators"],
    spaces: ["Studio/meeting rooms/kitchenettes with complimentary tea, coffee, ice machine and filtered water/Yoga studio"],
    maxCapacity: 120,
    standingCapacity: 60,
    facilities: ["External catering", "Screens", "Wi-Fi", "Conference call facilities", "Microphones", "Natural light space", "Accessible toilets", "Wheelchair accessible", "Changing rooms", "Storage space", "Quite space", "Sound System"],
    kidFriendly: true,
    availability: "Fair amount of availability throughout weekdays and weekends. Friday evenings and weekends have slightly more availability",
    suitableEvents: "yoga/pilates/meetings/AGMs/workshops/filming/photo shoots/conferences/company away days",
    pricing: "250",
    recurringDiscount: true,
    offPeakDiscount: false,
    hourlyRate: 250,
    minimumBooking: "For certain spaces, minimum of 4 hours (half day), for other spaces they can be booked by the hour",
    challenges: "Closing deals on private offices - we are in London Fields and I would say the demand for hot-desks are far more",
    platformValue: "",
    interested: true,
    coordinates: { lat: 51.5400, lng: -0.0500 }, // Approximate for Mentmore Terrace
    amenities: {
      foodBeverage: {
        inHouseCatering: [
          { name: "Extensive vegan menu", available: true },
          { name: "Complimentary water", available: true },
          { name: "Complimentary tea and coffee", available: true }
        ],
        externalCatering: [
          { name: "Buyout fee for external catering", available: true },
          { name: "Kitchen facilities available for guests", available: false }
        ],
        alcohol: {
          venueProvides: false,
          byoAllowed: true,
          corkageFee: true
        }
      },
      eventRules: {
        allowedEvents: [
          { name: "Promoted and ticketed events", available: true },
          { name: "No temporary Event Notice (TENs) available", available: false },
          { name: "No wedding licence", available: false }
        ],
        hostRules: [
          "Smoking/vaping outside only",
          "Outside catering is allowed",
          "BYO alcohol is allowed"
        ],
        cancellationPolicy: "Flexible"
      },
      amenities: [
        { name: "Wi-Fi available", available: true },
        { name: "Air conditioner", available: true },
        { name: "Storage space", available: true },
        { name: "Paid parking is available on-site", available: false },
        { name: "Projector", available: false },
        { name: "Whiteboard", available: false },
        { name: "Conference call facilities", available: true },
        { name: "PA system / speakers", available: true },
        { name: "Natural light", available: true },
        { name: "Quiet space", available: true },
        { name: "Paid parking facilities available nearby", available: true },
        { name: "Flatscreen TV", available: false },
        { name: "Flipchart", available: false },
        { name: "Alcohol licence", available: false }
      ]
    }
  },
  {
    id: 4,
    name: "Missionworks",
    image: "https://media.istockphoto.com/id/171259492/photo/wedding-reception.jpg?s=2048x2048&w=is&k=20&c=OZtPIGFNgHJHvw-wELkzIKH4Dh0i9K-4Yw6xIhdNh6w=",
    contact: "Sujith Mathew",
    email: "hello@missionworks.uk",
    role: "Community Manager",
    city: "London",
    rating: 4.6,
    address: "41 Iffley Road, W6 0PB",
    description: "Missionworks is a holistic coworking space inspired by the work of Swiss psychologist Jean Piaget, which provides an environment that nurtures the physical, social, and personal development of our Members to help them achieve their mission. Located in the historic Mission Hall, Brackenbury Village, Hammersmith.",
    vibe: ["Holistic", "Bright", "Charming"],
    organizesEvents: true,
    eventTypes: "Birthday Parties, Baby Showers, Wedding Receptions, and Networking events",
    platforms: ["Peerspace"],
    spaces: ["café styled communal area"],
    maxCapacity: 50,
    standingCapacity: 30,
    facilities: ["Wi-Fi", "Screens", "Natural light space", "Changing rooms", "Quite space", "External catering"],
    kidFriendly: true,
    availability: "Weekend evenings",
    suitableEvents: "Workshop, networking, birthday party, dinner party",
    pricing: "100",
    recurringDiscount: false,
    offPeakDiscount: false,
    hourlyRate: 100,
    minimumBooking: "Minimum 2 hour bookings",
    challenges: "",
    platformValue: "",
    interested: false,
    coordinates: { lat: 51.4900, lng: -0.2300 }, // Approximate for W6 0PB
    amenities: {
      foodBeverage: {
        inHouseCatering: [
          { name: "Extensive vegan menu", available: false },
          { name: "Complimentary water", available: true },
          { name: "Complimentary tea and coffee", available: true }
        ],
        externalCatering: [
          { name: "Buyout fee for external catering", available: true },
          { name: "Kitchen facilities available for guests", available: false }
        ],
        alcohol: {
          venueProvides: false,
          byoAllowed: true,
          corkageFee: true
        }
      },
      eventRules: {
        allowedEvents: [
          { name: "Promoted and ticketed events", available: true },
          { name: "No temporary Event Notice (TENs) available", available: false },
          { name: "No wedding licence", available: false }
        ],
        hostRules: [
          "Smoking/vaping outside only",
          "Outside catering is allowed",
          "BYO alcohol is allowed"
        ],
        cancellationPolicy: "Strict"
      },
      amenities: [
        { name: "Wi-Fi available", available: true },
        { name: "Air conditioner", available: false },
        { name: "Storage space", available: true },
        { name: "Paid parking is available on-site", available: false },
        { name: "Projector", available: false },
        { name: "Whiteboard", available: false },
        { name: "Conference call facilities", available: false },
        { name: "PA system / speakers", available: false },
        { name: "Natural light", available: true },
        { name: "Quiet space", available: true },
        { name: "Paid parking facilities available nearby", available: true },
        { name: "Flatscreen TV", available: true },
        { name: "Flipchart", available: false },
        { name: "Alcohol licence", available: false }
      ]
    }
  },
  {
    id: 5,
    name: "The Hearth",
    image: "https://images.squarespace-cdn.com/content/v1/5d3890f4857f6c00012dcb1d/1606672911655-42WS49VSC2PHSV6TU4AC/Lounge.jpg?format=2500w",
    contact: "Celine Acuna",
    email: "celine@thehearth.me",
    rating: 4.9,
    role: "Business Manager",
    address: "16 Lonsdale Road, Queen's Park, London NW6 6RD",
    description: "Spaciously designed over 2 floors in a light-filled mews house on Lonsdale Road in Queen's Park, The Hearth offers a variety of spaces for venue hire. The décor is calm and relaxing while thoughtfully designed with a warm colour palette. The Library upstairs has dramatic high ceilings, skylights and large windows, while the Lounge is calm and cosy with the Coffee / Wine bar serving drinks.",
    vibe: ["bright", "welcoming", "professional"],
    organizesEvents: true,
    eventTypes: "Entrepreneurs Circle, Writers Circle, Thrive Through Cancer Support Circle, Men's Circle, Death Café, Menopause Circle, Motherhood Story, Moon Circle, Women's Fertility Circle, Food Freedom Circle, Silver Sisters, Hearth Women Night, Cake & Chat, Lunch & Learn, book talks, arts & crafts workshop, parenting, marketing/professional, financial literacy, cacao ceremony, breathwork workshop",
    platforms: ["Tagvenue", "Peerspace", "Giggster", "Scouty", "Canvas", "and more"],
    spaces: ["Meeting room", "The Lounge", "The Library", "Co-working space"],
    maxCapacity: 100,
    city: "London",
    standingCapacity: 60,
    facilities: ["In-house catering", "External catering", "Alcoholic drinks", "Non-alcoholic drinks", "Projector", "Sound System", "Screens", "Wi-Fi", "Microphones", "Natural light space", "Accessible toilets", "Wheelchair accessible", "Changing rooms", "Quite space", "Parking"],
    kidFriendly: false,
    availability: "weekday evenings 6pm - 11pm, weekend full day 8am - 11pm",
    suitableEvents: "arts & crafts, workshops, meetings, support groups, discussion clubs, networking, social events, corporate events",
    pricing: "132",
    recurringDiscount: true,
    offPeakDiscount: false,
    hourlyRate: 132,
    minimumBooking: "2 hours minimum for dry hire, 3 hours minimum for wet hire",
    challenges: "While we receive lots of lovely enquiries, particularly for events involving children under 12 — the layout of our venue aren't always suitable for younger age groups, so we're not always able to say yes. Pricing can also be a consideration.",
    platformValue: "A valuable platform would help us attract aligned event organisers — not just more bookings, but the right kind. Key features would include: Audience targeting based on our values, Real-time calendar visibility, Custom booking preferences, Integrated messaging, payments, and contracts, Optional promotion tools for select events.",
    interested: true,
    coordinates: { lat: 51.5400, lng: -0.2000 }, // Approximate for NW6 6RD
    amenities: {
      foodBeverage: {
        inHouseCatering: [
          { name: "Extensive vegan menu", available: true },
          { name: "Complimentary water", available: true },
          { name: "Complimentary tea and coffee", available: true },
          { name: "Halal menu", available: true },
          { name: "Extensive gluten-free menu", available: true },
          { name: "Kosher menu", available: true }
        ],
        externalCatering: [
          { name: "Buyout fee for external catering", available: true },
          { name: "Kitchen facilities available for guests", available: true }
        ],
        alcohol: {
          venueProvides: true,
          byoAllowed: true,
          corkageFee: false
        }
      },
      eventRules: {
        allowedEvents: [
          { name: "Promoted and ticketed events", available: true },
          { name: "No temporary Event Notice (TENs) available", available: false },
          { name: "No wedding licence", available: false }
        ],
        hostRules: [
          "Smoking/vaping outside only",
          "Outside catering is allowed",
          "BYO alcohol is allowed"
        ],
        cancellationPolicy: "Flexible"
      },
      amenities: [
        { name: "Wi-Fi available", available: true },
        { name: "Air conditioner", available: true },
        { name: "Storage space", available: true },
        { name: "Paid parking is available on-site", available: true },
        { name: "Projector", available: true },
        { name: "Whiteboard", available: false },
        { name: "Conference call facilities", available: true },
        { name: "PA system / speakers", available: true },
        { name: "Natural light", available: true },
        { name: "Quiet space", available: true },
        { name: "Paid parking facilities available nearby", available: true },
        { name: "Flatscreen TV", available: false },
        { name: "Flipchart", available: false },
        { name: "Alcohol licence", available: true }
      ]
    }
  },
  {
    id: 6,
    name: "The Gladstone Arms",
    image: "https://images.unsplash.com/photo-1558210598-89ba75b1724e?q=80&w=2342&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    contact: "Megha Khanna",
    email: "info@thegladpub.co.uk",
    role: "Owner/director",
    address: "64 Lant Street, The GLADSTONE ARMS",
    description: "Intimate family-run live music pub, serving Indian fusion food & craft beers.",
    vibe: ["Cosy", "relaxed", "vibrant"],
    organizesEvents: true,
    city: "London",
    eventTypes: "Birthday parties, engagement parties, work events, Xmas parties/dinners",
    platforms: ["Just our website"],
    spaces: ["Main hall", "meeting room", "beer garden"],
    maxCapacity: 45,
    rating: 4.4,
    standingCapacity: 24,
    facilities: ["In-house catering", "Alcoholic drinks", "Non-alcoholic drinks", "Projector", "Sound System", "Screens", "Wi-Fi", "Natural light space", "Storage space", "Microphones"],
    kidFriendly: true,
    availability: "Weekday afternoons",
    suitableEvents: "Workshops, meetings, discussion clubs",
    pricing: "120",
    recurringDiscount: false,
    offPeakDiscount: false,
    hourlyRate: 120,
    minimumBooking: "No but we charge a £100 venue hire, and a further £100 that can be used as a bar tab",
    challenges: "Quiet afternoons",
    platformValue: "To get customers in during the quiet afternoons",
    interested: false,
    coordinates: { lat: 51.5000, lng: -0.0800 }, // Approximate for Lant Street
    amenities: {
      foodBeverage: {
        inHouseCatering: [
          { name: "Extensive vegan menu", available: true },
          { name: "Complimentary water", available: true },
          { name: "Complimentary tea and coffee", available: true },
          { name: "Halal menu", available: true }
        ],
        externalCatering: [
          { name: "Buyout fee for external catering", available: true },
          { name: "Kitchen facilities available for guests", available: false }
        ],
        alcohol: {
          venueProvides: true,
          byoAllowed: false,
          corkageFee: false
        }
      },
      eventRules: {
        allowedEvents: [
          { name: "Promoted and ticketed events", available: true },
          { name: "No temporary Event Notice (TENs) available", available: false },
          { name: "No wedding licence", available: false }
        ],
        hostRules: [
          "Smoking/vaping outside only",
          "Outside catering is allowed",
          "BYO alcohol is not allowed"
        ],
        cancellationPolicy: "Moderate"
      },
      amenities: [
        { name: "Wi-Fi available", available: true },
        { name: "Air conditioner", available: false },
        { name: "Storage space", available: true },
        { name: "Paid parking is available on-site", available: false },
        { name: "Projector", available: true },
        { name: "Whiteboard", available: false },
        { name: "Conference call facilities", available: false },
        { name: "PA system / speakers", available: true },
        { name: "Natural light", available: true },
        { name: "Quiet space", available: false },
        { name: "Paid parking facilities available nearby", available: true },
        { name: "Flatscreen TV", available: true },
        { name: "Flipchart", available: false },
        { name: "Alcohol licence", available: true }
      ]
    }
  },
  // Austin, TX venues
  // {
  //   id: 6,
  //   name: "Austin Music Hall",
  //   contact: "Sarah Johnson",
  //   email: "sarah@austinmusichall.com",
  //   role: "Event Manager",
  //   address: "1236 E 6th St, Austin, TX 78702",
  //   city: "Austin",
  //   description: "Historic music venue perfect for concerts, private events, and corporate gatherings.",
  //   vibe: ["Vibrant", "Historic", "Music-focused"],
  //   organizesEvents: true,
  //   eventTypes: "Concerts, private parties, corporate events, weddings",
  //   platforms: ["Instagram", "Facebook", "Website"],
  //   spaces: ["Main hall", "Green room", "Bar area"],
  //   maxCapacity: 200,
  //   standingCapacity: 200,
  //   facilities: ["Sound system", "Lighting", "Bar", "Parking"],
  //   kidFriendly: false,
  //   availability: "Evenings and weekends",
  //   suitableEvents: "Concerts, parties, corporate events, weddings",
  //   pricing: "Starting at $150/hour",
  //   recurringDiscount: true,
  //   offPeakDiscount: true,
  //   minimumBooking: "3 hours",
  //   hourlyRate: 150,
  //   coordinates: { lat: 30.2672, lng: -97.7431 }
  // },
  // {
  //   id: 7,
  //   name: "South Austin Event Space",
  //   contact: "Mike Rodriguez",
  //   email: "mike@southaustinevents.com",
  //   role: "Owner",
  //   address: "456 S Lamar Blvd, Austin, TX 78704",
  //   city: "Austin",
  //   rating: 4.8,
  //   description: "Modern event space with outdoor patio and full catering kitchen.",
  //   vibe: ["Modern", "Outdoor", "Flexible"],
  //   organizesEvents: true,
  //   eventTypes: "Weddings, corporate events, private parties, workshops",
  //   platforms: ["Website", "Google Business"],
  //   spaces: ["Main room", "Outdoor patio", "Kitchen", "Storage"],
  //   maxCapacity: 80,
  //   standingCapacity: 80,
  //   facilities: ["Full kitchen", "Outdoor space", "Parking", "WiFi"],
  //   kidFriendly: true,
  //   availability: "7 days a week",
  //   suitableEvents: "Weddings, corporate events, workshops, private parties",
  //   pricing: "Starting at $100/hour",
  //   recurringDiscount: true,
  //   offPeakDiscount: true,
  //   minimumBooking: "4 hours",
  //   hourlyRate: 100,
  //   coordinates: { lat: 30.2500, lng: -97.7500 }
  // },
  // {
  //   id: 8,
  //   name: "Downtown Austin Conference Center",
  //   contact: "Jennifer Chen",
  //   email: "jennifer@downtownaustincc.com",
  //   role: "Director",
  //   address: "789 Congress Ave, Austin, TX 78701",
  //   city: "Austin",
  //   rating: 4.7,
  //   description: "Professional conference center in the heart of downtown Austin.",
  //   vibe: ["Professional", "Modern", "Corporate"],
  //   organizesEvents: true,
  //   eventTypes: "Conferences, meetings, corporate events, training sessions",
  //   platforms: ["LinkedIn", "Website", "Eventbrite"],
  //   spaces: ["Conference rooms", "Main hall", "Breakout rooms", "Lobby"],
  //   maxCapacity: 300,
  //   standingCapacity: 300,
  //   facilities: ["AV equipment", "Catering", "Parking", "WiFi", "Projectors"],
  //   kidFriendly: false,
  //   availability: "Business hours and evenings",
  //   suitableEvents: "Conferences, meetings, training, corporate events",
  //   pricing: "Starting at $200/hour",
  //   recurringDiscount: true,
  //   offPeakDiscount: false,
  //   minimumBooking: "2 hours",
  //   hourlyRate: 200,
  //   coordinates: { lat: 30.2672, lng: -97.7431 }
  // },
  // {
  //   id: 9,
  //   name: "East Austin Art Gallery",
  //   contact: "Maria Garcia",
  //   email: "maria@eastartgallery.com",
  //   role: "Gallery Director",
  //   address: "321 E 5th St, Austin, TX 78701",
  //   city: "Austin",
  //   rating: 4.5,
  //   description: "Contemporary art gallery perfect for art shows, private events, and cultural gatherings.",
  //   vibe: ["Artistic", "Contemporary", "Cultural"],
  //   organizesEvents: true,
  //   eventTypes: "Art exhibitions, private events, cultural events, workshops",
  //   platforms: ["Instagram", "Facebook", "Website"],
  //   spaces: ["Main gallery", "Studio space", "Outdoor courtyard"],
  //   maxCapacity: 60,
  //   standingCapacity: 60,
  //   facilities: ["Gallery lighting", "Sound system", "Outdoor space", "Kitchenette"],
  //   kidFriendly: true,
  //   availability: "Evenings and weekends",
  //   suitableEvents: "Art shows, private events, workshops, cultural events",
  //   pricing: "Starting at $80/hour",
  //   recurringDiscount: true,
  //   offPeakDiscount: true,
  //   minimumBooking: "3 hours",
  //   hourlyRate: 80,
  //   coordinates: { lat: 30.2700, lng: -97.7400 }
  // },
  // {
  //   id: 10,
  //   name: "West Austin Rooftop Venue",
  //   contact: "David Thompson",
  //   email: "david@westaustinrooftop.com",
  //   role: "Venue Manager",
  //   address: "987 W 6th St, Austin, TX 78703",
  //   city: "Austin",
  //   rating: 4.9,
  //   description: "Stunning rooftop venue with panoramic views of downtown Austin.",
  //   vibe: ["Upscale", "Scenic", "Outdoor"],
  //   organizesEvents: true,
  //   eventTypes: "Weddings, corporate events, private parties, networking events",
  //   platforms: ["Website", "Instagram", "Wedding Wire"],
  //   spaces: ["Rooftop terrace", "Indoor lounge", "Bar area", "Dance floor"],
  //   maxCapacity: 120,
  //   standingCapacity: 120,
  //   facilities: ["Full bar", "Catering kitchen", "Sound system", "Lighting", "Heating"],
  //   kidFriendly: false,
  //   availability: "Evenings and weekends",
  //   suitableEvents: "Weddings, corporate events, private parties, networking",
  //   pricing: "Starting at $250/hour",
  //   recurringDiscount: false,
  //   offPeakDiscount: true,
  //   minimumBooking: "4 hours",
  //   hourlyRate: 250,
  //   coordinates: { lat: 30.2600, lng: -97.7500 }
  // }
];

const allCities = REAL_VENUE_DATA.map(item => item.city);
// export const ukCities = [...new Set(allCities)];

// Create combined search options for type-ahead
const uniqueCities = [...new Set(allCities)];
const venueOptions = REAL_VENUE_DATA.map(venue => `${venue.name} - ${venue.city}`);
export const searchOptions = [
  ...uniqueCities,
  ...venueOptions
];

// Default 5 most popular options
export const defaultSearchOptions = [
  'London',
];

const allEventTypes = REAL_VENUE_DATA.map(item => item.eventTypes);
export const eventTypes = [...new Set(allEventTypes)];

// Helper function to extract venue name from location string
export const extractVenueNameFromLocation = (locationString) => {
  if (locationString.includes(' - ')) {
    return locationString.split(' - ')[0];
  }
  return locationString;
};

// Helper function to extract address from location string
export const extractAddressFromLocation = (locationString) => {
  if (locationString.includes(' - ')) {
    return locationString.split(' - ')[1];
  }
  return locationString;
};

// Helper function to format venue data for display
export const formatVenueForDisplay = (venue) => {
  // Handle both old hardcoded data format and new API format
  const cityName = venue.area ? venue.area.split(',')[venue.area.split(',').length - 2]?.trim() || 'London' : 
                   venue.address ? venue.address.split(',')[venue.address.split(',').length - 2]?.trim() || 'London' : 'London';
  
  // Use primary image from API if available, fallback to first image, then valid placeholder
  const imageUrl = venue.primaryImageUrl || venue.primary_image_url ||
    venue.image || (venue.images?.[0]?.image_url) ||
    venueImages[(venue.id || 0) % venueImages.length];
  
  // Handle different capacity field names - prioritize capacity over maxCapacity
  const capacity = venue.capacity || venue.maxCapacity || 0;
  
  // Handle different hourly rate field names
  const hourlyRate = venue.hourlyRate || venue.hourly_rate || 0;
  const showPricing = shouldShowVenuePricing(venue);
  
  // Handle different vibe formats
  const vibeText = venue.vibes ? venue.vibes.join(', ').toUpperCase() : 
                   venue.vibe ? venue.vibe.join(', ').toUpperCase() : '';
  
  return {
    id: venue.id,
    name: venue.name,
    location: venue.area || venue.address,
    price: showPricing ? (hourlyRate > 0 ? `£${hourlyRate}/hr` : 'Contact for pricing') : null,
    hide_price: !showPricing,
    capacity: `${capacity} people`,
    rating: venue.rating,
    distance: `5 min from ${cityName}`, // This will be overridden by metro distance service
    image: imageUrl,
    vibe: vibeText,
    coordinates: venue.coordinates,
    description: venue.description,
    facilities: venue.facilities,
    contact: venue.contact_name || venue.contact,
    email: venue.contact_email || venue.email,
    availability: venue.availability,
    suitableEvents: venue.suitableEvents,
    minimumBooking: venue.minimumBooking
  };
};
